<template>
  <Module
    :id="selectionData.conf.id"
    :isLoaded="$store.getters.getLvl1Loaded"
  >
    <template>
      <div class="present">
        <ul
          v-if="$store.getters.getSelectedItem.data !== null && $store.getters.getSelectedItem.data.type === 'level_1'"
          class="present__list"
        >
          <ModulePresentItem
            v-for="(product, index) in getListItems"
            :key="index"
            :index="index"
            :id="Number(product.id) || Number(product.product)"
            :photo="{ src: product.photos[$store.getters.groupAbb][0].original, alt: product.name }"
            :name="product.name"
            :description="productDetailStringBold1(product)"
            :sku="product.sku"
            :product="product"
            :showReplaceNotice="product.showReplaceNotice"
          />

          <ModulePresentItem
            :photo="{ src: getImageUrl('icon-customize-colored.svg'), alt: '' }"
            name="Enthaltene Produkte ändern"
            description="Sie können einzelne Delikatessen tauschen oder ergänzen"
            :linkTo="`/zusammenstellen?__addLevel3s=${$store.getters.getSelectedItem.includedProducts().map(p => {
              if (p.replaced) {
                return p.replaceData.id;
              } else {
                return p.product;
              }
            }).join(',')}`"
          />

          <ModulePresentItem
            :photo="{ src: getImageUrl('icon-gift-colored.svg'), alt: '' }"
            name="Präsent selbst zusammenstellen"
            description="Wählen Sie jede Delikatesse einzeln"
            linkTo="/zusammenstellen"
          />
        </ul>

        <div v-else>
          <EmptyDataset title="Noch kein Präsent ausgewählt">
            <template v-slot:icon>
              <svg viewBox="0 0 64 56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.135025 20.6582C0.135025 20.6582 0.135025 20.6582 0.135025 20.5232C0.270046 20.3882 0.270047 20.2532 0.405068 20.2532L30.9198 1.75527C31.0549 1.62025 31.1899 1.62025 31.3249 1.62025L62.9198 0C63.4599 0 63.73 0.270042 64 0.675105C64 0.810127 64 0.945148 64 0.945148V9.99156C64 10.3966 63.865 10.6667 63.4599 10.8017L55.6287 15.6624L62.5148 20.1181C62.7848 20.3882 62.9198 20.6582 62.9198 21.0633L62.5148 34.9705C62.5148 35.2405 62.3797 35.6456 62.1097 35.7806L31.865 55.7637C31.73 55.7637 31.5949 55.8987 31.4599 55.8987C31.3249 55.8987 31.1899 55.8987 31.0549 55.7637L0.810131 35.7806C0.540088 35.6456 0.405068 35.2405 0.405068 34.9705L1.03918e-06 21.0633C1.03918e-06 20.9283 4.12756e-06 20.7932 0.135025 20.6582ZM31.73 3.64557L4.59072 19.8481L32.5401 19.173L59.1392 2.16034L31.73 3.64557ZM4.18566 21.8734L11.4768 26.4641H28.4895L31.1899 21.1983L4.18566 21.8734ZM61.9747 9.45148V2.83544L34.5654 20.3882L38.211 23.8987L61.9747 9.45148ZM53.6034 16.7426L47.5274 20.6582L53.7384 24.8439L59.9494 20.9283L53.6034 16.7426ZM32.4051 53.0633L60.6245 34.2954L60.8945 22.8186L32.4051 40.5063V53.0633ZM31.3249 38.7511L51.8481 26.0591L45.5021 21.8734L38.481 26.1941C38.076 26.4641 37.5359 26.3291 37.2658 26.0591L33.0802 22.0084L29.9747 28.0844C29.8397 28.4894 29.4346 28.6245 29.0295 28.6245H14.7173L31.3249 38.7511ZM2.16034 34.2954L30.3797 53.0633V40.5063L1.8903 22.8186L2.16034 34.2954Z" fill="currentColor"/></svg>
            </template>
            <template v-slot:content>
              <p>Hier werden die enthaltenen Delikatessen angezeigt, sobald Sie ein Präsent ausgewählt haben.</p>
            </template>
          </EmptyDataset>
        </div>
      </div>
    </template>
  </Module>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import { helperMixin } from '@/mixins/HelperMixin';
import { replaceMixin } from '@/mixins/ReplaceMixin';

import Module from '@/components/Composer/Module';
import ModulePresentItem from '@/components/Composer/ModulePresentItem';
import EmptyDataset from '@/components/Common/EmptyDataset';

export default {
  name: 'ModulePresent',
  props: ['selectionData'],
  mixins: [logicMixin, helperMixin, replaceMixin],
  components: {
    Module,
    ModulePresentItem,
    EmptyDataset
  },
  computed: {
    getListItems() {
      const ret = [];
      this.$store.getters.getSelectedItem.includedProducts().forEach(item => {
        if (item.replaced) {
          item = { ...item.replaceData, quantity: item.quantity };
          for (var j = 0; j < item.quantity; j++) {
            ret.push({
              ...item,
              showReplaceNotice: true
            });
          }
        } else {
          for (var i = 0; i < item.quantity; i++) {
            ret.push({
              ...item,
            });
          }
        }
      });

      return ret;
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * Present Module
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Present's tab content
 * @since 2021-08-17
**/

$component: 'present';
$listVerticalSpace: map-get($spacers, 1) * 2.8;

.#{$component} {
  &__list {
    @include unlist;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
